import { styled } from '@mui/material';

export const PolicyStreamButtonsContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 3,
});
